import { Typography } from "@mui/material";
import { useLocalizedProperty } from "../../utils";

export const OfferStatusText = (props) => {
    const { status_key } = props.status;
    const getLocalizedProperty = useLocalizedProperty();
    const statusText = getLocalizedProperty(props.status, "status_name");

    const colors = {
        sent: "#0B94D8",
        Accepted: "#068e06",
        Failure: "#D80B0B",
        underPreparation: "#ffbb00ff",
        Cancelled: "#585858ff",
        RemovedFromOffer: "#D80B0B",
    };

    if (!(status_key in colors)) {
        return <Typography>{statusText}</Typography>;
    }

    return <Typography color={colors[status_key]}>{statusText}</Typography>;
};
